module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"modification":"modification de :","organizationTitle":"Mon Organisation","organizationDetails":"Coordonnées","organizationCredits":"Crédits"},"en":{"modification":"change of :","organizationTitle":"My Organization","organizationDetails":"Details","organizationCredits":"Credits"}}')
  delete Component.options._Ctor
}
